export const BOOKING_STATUS_ARRAY = [
    { name: "Pending", filterName: 'Open requests', value: 1 },
    { name: "Approved", filterName: 'Approved bookings', value: 2 },
    { name: "Declined", filterName: 'Declined bookings', value: -1 },
    { name: "Cancelled", filterName: 'Cancelled bookings', value: -2 }
];

export const HISTORY_STATUS_ARRAY = [
    { name: "All", filterName: 'All', value: 1 },
    { name: "Approved", filterName: 'Approved bookings', value: 2 },
    { name: "Declined", filterName: 'Declined bookings', value: -1 },
    { name: "Cancelled", filterName: 'Cancelled bookings', value: -2 }
]

export const MODAL_TYPE = {
    CREATE: 'create',
    EDIT: 'edit'
}

export const CALENDAR_VIEWS = {
    DAY: 'day',
    WEEK: 'week'
}

export const VIEWS = {
    BOOKINGS: 'BOOKINGS',
    SPACES: 'SPACES',
    HISTORY: 'HISTORY'
};

export const BOOKING_STATUS = {
    NO_BOOKING: 0,
    PENDING: 1,
    APPROVED: 2,
    DECLINED: -1,
    CANCELLED: -2,
};

export const SPACE_STATUS = {
    AVAILABLE: { value: 1, label: 'Available' },
    NOT_AVAILABLE: { value: 0, label: ' Not Available' },
    HIDDEN: { value: -1, label: 'Hidden' }
};

type objType = {
    [key: string]: any
}

export const BOOKING_ERROR_MSGS: objType = {
    'INVALID_START_TIME': 'Selected start time is not valid.',
    'INVALID_END_TIME': 'Selected end time is not valid.',
    'START_IS_AFTER_END': 'End time should be after start time.',
    'ADVANCED_BOOKING_TIME_FAILURE': 'Advance booking time failure.',
    'SLOT_NOT_AVAILABLE': 'Selected time slot is not available.',
    'HOUR_LIMIT_EXCEEDED': 'Maximum booking period exceeded.',
};

export const SPACE_FACILITIES = ['Big Screen', 'Loud Speaker', 'Presenting', 'Partying'];

export const FUTURE_BOOKING_CSV_EXPORT_FIELDS = ['Building', 'Space', 'Start Time', 'End Time', 'Booking Duration (hours)', 'Booked By', 'Booking Reason', 'Approved By', 'Status', 'Per Hour Cost($)'];
export const HISTORY_BOOKING_CSV_EXPORT_FIELDS = ['Building', 'Space', 'Start Time', 'End Time', 'Booking Duration (hours)', 'Booked By', 'Booking Reason', 'Approved By', 'Approved At', 'Cancelled By', 'Cancelled At', 'Declined By', 'Declined At', 'Decline Reason', 'Status', 'Per Hour Cost($)'];

export const BOOKING_TIME_FORMAT = "dddd, DD MMMM hh:mm A";

export const RECURRENCES = {
    ONETIME: "ONETIME",
    DAILY: "DAILY",
    WEEKLY: "WEEKLY",
    MONTHLY: "MONTHLY"
}

export const RECURRING_APPROVES = {
    THIS: "THIS",
    UPCOMING: "UPCOMING",
    ALL: "ALL"
}